import { Grid, Switch, Typography } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { Controller, useFormContext } from 'react-hook-form'

export const MotorcyclesYesNoQuestions = ({ isLojackFactordDisabled, isNeedOdometerCheck, isAntiLockFactorDisabled }) => {
  const methods = useFormContext()

  return (
    <>
      {!isLojackFactordDisabled && (
        <Grid item xs={12}>
          <FlexView className="switch_question_style">
            <Typography>Does your motorcycle have anti-lock brakes?</Typography>
            <Controller
              name="anti_lock_brakes"
              control={methods.control}
              defaultValue={methods.control.defaultValuesRef.current.anti_lock_brakes || false}
              as={<Switch color="primary" />}
            />
          </FlexView>
        </Grid>
      )}
      {isNeedOdometerCheck && (
        <Grid item xs={12}>
          <FlexView className="switch_question_style">
            <Typography>Does your vehicle include an odometer?</Typography>
            <Controller
              name="is_motorcycle_include_odometer"
              control={methods.control}
              defaultValue={methods.control.defaultValuesRef.current.is_motorcycle_include_odometer || false}
              as={<Switch color="primary" />}
              valueName="checked"
            />
          </FlexView>
        </Grid>
      )}
      {!isAntiLockFactorDisabled && (
        <Grid item xs={12}>
          <FlexView className="switch_question_style">
            <Typography>Does your motorcycle have anti-theft devices?</Typography>
            <Controller
              name="anti_theft_device"
              control={methods.control}
              defaultValue={methods.control.defaultValuesRef.current.anti_theft_device || false}
              as={<Switch color="primary" />}
            />
          </FlexView>
        </Grid>
      )}
      <Grid item xs={12}>
        <FlexView className="switch_question_style">
          <Typography>Will you be making payments on this motorcycle? (motorcycle lien)</Typography>
          <Controller
            name="has_lienholder"
            control={methods.control}
            defaultValue={methods.control.defaultValuesRef.current.has_lienholder || false}
            as={<Switch color="primary" />}
          />
        </FlexView>
      </Grid>
    </>
  )
}
